import React, { useState } from 'react'

// contexts
import { AuthenticationContext } from '../contexts/authentication';

// components
import NavigationBar from '../components/navigation/NavigationBar/NavigationBar.component';
import MainContent from '../core/MainContent/MainContent.component';

// ⭐ ADD THIS IMPORT ⭐
import NotificationHandler from '../components/NotificationHandler';

const Pages = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(sessionStorage.getItem('asiAdminAuthToken') ? true : false)

    const setAuthenticationStatus = (token = null, refresh = null) => {
        if(token && refresh) {
            sessionStorage.setItem("asiAdminRefreshToken", refresh)
            sessionStorage.setItem("asiAdminAuthToken", token);
            setIsLoggedIn(true)
        } else {
            sessionStorage.removeItem("asiAdminRefreshToken")
            sessionStorage.removeItem("asiAdminAuthToken")
            setIsLoggedIn(false)
        }
    }

    return (
        <AuthenticationContext.Provider value={{
            isLoggedIn,
            setAuthenticationStatus,
        }}>
            <NavigationBar />
            <MainContent />
            
            {/* ⭐ ADD THIS LINE - NotificationHandler at the end ⭐ */}
            <NotificationHandler />
        </AuthenticationContext.Provider>
    )
    
}

export default Pages;
